import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { fetchApiData } from "../../store/slicers/apiSlicer.js";
import AppLayout from "../layouts/AppLayout.jsx";

const ContentAnnonceDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [annonce, setAnnonce] = useState(null);
  const [currentLang, setCurrentLang] = useState(() => {
    return localStorage.getItem("onpr_language") || "fr";
  });

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.annonceDetail,
    isLoading: state.apiData?.loading?.annonceDetail,
  }));

  useEffect(() => {
    dispatch(
      fetchApiData({
        url: `annonces/${id}`,
        itemKey: "annonceDetail",
      })
    );
  }, [id]);

  useEffect(() => {
    if (data) {
      setAnnonce(data);
    }
  }, [data]);

  const handleBack = () => {
    history.goBack();
  };

  const getTitle = () => {
    if (!annonce) return "";
    return currentLang === "fr" ? annonce.title : annonce.title_en;
  };

  const getBody = () => {
    if (!annonce) return "";
    return currentLang === "fr" ? annonce.body : annonce.body_en;
  };

  if (isLoading) {
    return (
      <div className="annonce-detail-container">
        <div className="text-center py-5">
          <i
            className="pi pi-spin pi-spinner"
            style={{ fontSize: "3rem", color: "#00a652" }}
          ></i>
          <p>Chargement de l'annonce...</p>
        </div>
      </div>
    );
  }

  if (!annonce) {
    return (
      <div className="annonce-detail-container">
        <div className="no-data-placeholder">
          <i
            className="pi pi-exclamation-circle"
            style={{ fontSize: "4rem", color: "#d32f2f" }}
          ></i>
          <p>Annonce non trouvée</p>
          <button onClick={handleBack} className="back-btn">
            <i className="pi pi-arrow-left"></i> Retour
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="annonce-detail-container">
      <div className="detail-card">
        <div className="detail-icon-section">
          <div className="detail-icon">
            <i className="pi pi-megaphone"></i>
          </div>
        </div>

        <div className="detail-content">
          <h1 className="detail-title">{getTitle()}</h1>

          <div className="detail-meta">
            <span className="meta-item">
              <i className="pi pi-calendar"></i>
              Publié le{" "}
              {new Date(annonce.created_at).toLocaleDateString("fr-FR", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </span>
            {annonce.updated_at !== annonce.created_at && (
              <span className="meta-item">
                <i className="pi pi-refresh"></i>
                Mis à jour le{" "}
                {new Date(annonce.updated_at).toLocaleDateString("fr-FR", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            )}
          </div>

          <div className="detail-divider"></div>

          <div
            className="detail-body"
            dangerouslySetInnerHTML={{ __html: getBody() }}
          />

          {annonce.file_attachment && (
            <div className="attachment-section">
              <h3 className="attachment-title">
                <i className="pi pi-paperclip"></i> Pièce jointe
              </h3>
              <a
                href={annonce.file_attachment}
                target="_blank"
                rel="noopener noreferrer"
                className="attachment-link"
              >
                <i className="pi pi-download"></i>
                Télécharger le document
              </a>
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .annonce-detail-container {
          max-width: 900px;
          margin: 30px auto;
          padding: 0 20px;
        }
        .detail-header {
          margin-bottom: 20px;
        }
        .back-btn {
          background: #00a652;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 5px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-weight: 600;
          transition: all 0.3s;
        }
        .back-btn:hover {
          background: #d32f2f;
          transform: translateY(-2px);
        }
        .detail-card {
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }
        .detail-icon-section {
          background: linear-gradient(135deg, #00a652 0%, #2d8659 100%);
          padding: 40px;
          text-align: center;
        }
        .detail-icon {
          width: 80px;
          height: 80px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
        }
        .detail-icon i {
          font-size: 2.5rem;
          color: white;
        }
        .detail-content {
          padding: 40px;
        }
        .detail-title {
          color: #00a652;
          font-size: 1.8rem;
          font-weight: 700;
          margin-bottom: 20px;
          line-height: 1.4;
        }
        .detail-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          margin-bottom: 20px;
        }
        .meta-item {
          color: #666;
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .meta-item i {
          color: #d32f2f;
        }
        .detail-divider {
          height: 3px;
          background: linear-gradient(to right, #00a652, #d32f2f);
          margin: 25px 0;
          border-radius: 2px;
        }
        .detail-body {
          color: #333;
          font-size: 1rem;
          line-height: 1.8;
          margin-bottom: 30px;
        }
        .detail-body h1,
        .detail-body h2,
        .detail-body h3 {
          color: #00a652;
          margin-top: 25px;
          margin-bottom: 15px;
        }
        .detail-body h1 {
          font-size: 1.6rem;
        }
        .detail-body h2 {
          font-size: 1.4rem;
        }
        .detail-body h3 {
          font-size: 1.2rem;
        }
        .detail-body p {
          margin-bottom: 15px;
        }
        .detail-body ul,
        .detail-body ol {
          margin-left: 25px;
          margin-bottom: 15px;
        }
        .detail-body li {
          margin-bottom: 8px;
        }
        .detail-body strong {
          color: #00a652;
          font-weight: 600;
        }
        .detail-body a {
          color: #d32f2f;
          text-decoration: none;
        }
        .detail-body a:hover {
          text-decoration: underline;
        }
        .attachment-section {
          background: #f5f5f5;
          padding: 20px;
          border-radius: 8px;
          border-left: 4px solid #00a652;
        }
        .attachment-title {
          color: #00a652;
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 15px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .attachment-link {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: #00a652;
          color: white;
          padding: 12px 24px;
          border-radius: 5px;
          text-decoration: none;
          font-weight: 600;
          transition: all 0.3s;
        }
        .attachment-link:hover {
          background: #d32f2f;
          transform: translateY(-2px);
        }
        .no-data-placeholder {
          text-align: center;
          padding: 60px 20px;
        }
        .no-data-placeholder p {
          color: #999;
          font-size: 1.1rem;
          margin-top: 15px;
          margin-bottom: 20px;
        }
        .text-center {
          text-align: center;
        }
        .py-5 {
          padding-top: 3rem;
          padding-bottom: 3rem;
        }
        @media (max-width: 768px) {
          .detail-content {
            padding: 25px;
          }
          .detail-title {
            font-size: 1.5rem;
          }
          .detail-meta {
            flex-direction: column;
            gap: 10px;
          }
          .attachment-link {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </div>
  );
};

const AnnonceDetail = () => {
  return (
    <AppLayout>
      <ContentAnnonceDetail />
    </AppLayout>
  );
};

export default AnnonceDetail;
